import { getPercentage } from '../../../stores/utils';

export const formatCommas = (value) => new Intl.NumberFormat().format(value);

export const getComponentNameFromStorage = (auctionID) => {
  const dashboardComponentToUse = JSON.parse(
    sessionStorage.getItem('dashboardCardViewName'),
  );

  const componentNameFromStorage =
    (dashboardComponentToUse && dashboardComponentToUse[auctionID]) ||
    'mediaUpload';
  return componentNameFromStorage;
};

export const loadProxyBidAndUserCountList = (
  pxyBidCount,
  membersCount,
  userCount,
  uniqueUsersCount,
  auctionID,
  auctionName,
) => [
  {
    aliasText: 'Proxy Bids',
    auctionID,
    auctionName,
    color: 'yellow',
    helpText: `The total number of proxy bids that are uploaded to the auction.`,
    iconClass: 'gavel',
    popupPosition: 'right center',
    qty: pxyBidCount,
    text: `Proxy Bids`,
    value: 'ProxyBids',
  },
  {
    aliasText: 'Members Imported',
    auctionID,
    auctionName,
    color: 'teal',
    helpText:
      'The number of Dealers/Lenders that were imported into the auction. These are the people authorized to join the auction.',
    iconClass: 'user',
    popupPosition: 'right center',
    qty: membersCount,
    text: `Authorized Members`,
    value: 'AuthorizedMembers',
  },
  {
    aliasText: 'Total Gavel Clicks',
    auctionID,
    auctionName,
    color: 'teal',
    helpText:
      'The number of times one of the Authorized Members clicked the gavel (This counts multiple requests by the same account across any devices (The total will only increase)',
    iconClass: 'user',
    popupPosition: 'right center',
    qty: userCount,
    text: `Registered Members`,
    value: 'Members',
  },
  {
    aliasText: 'Unique Gavel Clicks',
    auctionID,
    auctionName,
    color: 'teal',
    helpText:
      'The unique number of people clicking the gavel to join the auction.',
    iconClass: 'user',
    popupPosition: 'right center',
    qty: uniqueUsersCount,
    text: `Unique Registered Members`,
    value: 'UniqueMembers',
  },
  {
    aliasText: 'Transcript Report',
    auctionID,
    auctionName,
    color: 'blue',
    helpText:
      'A historical log of all events that occur in real-time as an auction progresses. This report can be exported to Excel for further analysis.',
    iconClass: 'file excel outline',
    popupPosition: 'right center',
    text: `Transcript Report`,
    value: 'auctionTranscriptReport',
  },
];

export const getProductStatusButtonColor = (current, total) => {
  const pct = getPercentage(current, total);
  if (pct < 100 && pct >= 95) return 'orange';
  if (pct < 95) return 'yellow';
  return 'green';
};

export const getMediaUploadButtonColor = (current, total, errors) => {
  const pct = getPercentage(current, total);
  if (errors > 0) return 'red';
  if (pct > 99) return 'green';
  return 'yellow';
};
